// ============================================
// もっと見る
// ============================================
let textHeight = "";
class ReadMoreLine {
	constructor(options) {
		this.wrap = options.wrap; // ラッパー要素
		this.text = options.text; // 表示するテキスト要素
		this.textRwd = options.textRwd; // レスポンシブ時に表示するテキスト要素
		this.btn = options.btn; // トグルボタン
		this.inActiveClassName = options.inActiveClassName; //高さが満たない場合に付与するクラス名
		this.toggleClassName = options.toggleClassName; // トグル時に付与するクラス名
		this.breakPointPc = options.breakPointPc || 768; // ブレークポイント（デフォルトは768px）
		this.mql = window.matchMedia(
			`all and (min-width: ${this.breakPointPc}px)`
		); // メディアクエリリスナー
		this.lineHeight = parseFloat(
			getComputedStyle(this.text).getPropertyValue("line-height")
		); // 1行の高さをcssから取得
		this.numLines = options.numLines || 12; // 表示する行数（デフォルトは12行）
		this.numLinesRwd = options.numLinesRwd || this.numLines; // レスポンシブ時に表示する行数
		this.resizeTimeout = null; // リサイズイベントのタイムアウト
		this.lastWidth = window.innerWidth; // リサイズイベントの最終幅
		this.openTxt = options.openTxt; //閉じた状態のテキスト（Read More）
		this.closeTxt = options.closeTxt; //開いた状態のテキスト（Closed）

		this.bindEvents(); // イベントのバインド
		this.adjustHeightForMedia(); // メディアクエリに応じて高さを調整
	}

	// テキストの高さ調整
	adjustTextHeight() {
		const maxHeight = this.lineHeight * this.getCurrentNumLines(); // 最大の高さ
		textHeight = this.text.scrollHeight; // テキストの高さ

		// テキストの高さが最大の高さを超えた場合
		if (textHeight > maxHeight) {
			this.text.style.height = `${maxHeight}px`; // 最大の高さを設定
			this.wrap.classList.remove(this.inActiveClassName); // トグルクラスを削除
		} else {
			this.text.style.height = `${textHeight}px`; // 高さを解除
			this.wrap.classList.add(this.inActiveClassName); // トグルクラスを追加
		}
	}

	// 現在の行数を取得
	getCurrentNumLines() {
		return this.mql.matches ? this.numLinesRwd : this.numLines; // レスポンシブ時の行数を取得
	}

	// メディアクエリに応じて高さを調整
	adjustHeightForMedia() {
		this.adjustTextHeight(); // テキストの高さ調整
	}

	// テキストの高さをトグル
	toggleTextHeight() {
		this.wrap.classList.toggle(this.toggleClassName); // トグルクラスを切り替え
		// トグルクラスが付与されている場合
		if (this.wrap.classList.contains(this.toggleClassName)) {
			this.text.style.height = `${textHeight}px`; // 高さを解除
			this.btn.textContent = this.closeTxt;
		} else {
			this.text.style.height = `${this.lineHeight * this.getCurrentNumLines()
				}px`; // 高さを設定
			this.btn.textContent = this.openTxt;
		}
	}

	// リサイズイベント
	handleResize() {
		// リサイズイベントのデバウンス
		if (this.resizeTimeout) {
			clearTimeout(this.resizeTimeout); // 以前に設定されたタイムアウトを解除
		}
		// 新しいリサイズイベントのタイムアウトを設定
		this.resizeTimeout = setTimeout(() => {
			// アニメーションフレームをリクエスト
			requestAnimationFrame(() => {
				// ウィンドウ幅が変更された場合のみ処理を実行
				if (window.innerWidth !== this.lastWidth) {
					this.lastWidth = window.innerWidth; // 最終幅を更新
					this.adjustHeightForMedia(); // メディアクエリに応じて高さを調整
					// トグルクラスが付与されている場合
					if (this.wrap.classList.contains(this.toggleClassName)) {
						this.btn.textContent = this.openTxt; //ボタンのテキストを変更
						this.wrap.classList.toggle(this.toggleClassName); //クラスを削除
					}
				}
			});
		}, 150); // 150msのデバウンス
	}

	// イベントのバインド
	bindEvents() {
		// トグルボタンが存在する場合
		if (this.btn) {
			this.btn.addEventListener(
				"click",
				this.toggleTextHeight.bind(this)
			); // トグルボタンのクリックイベントにtoggleTextHeightメソッドを設定
		}
		this.mql.addEventListener(
			"change",
			this.adjustHeightForMedia.bind(this)
		); // メディアクエリの変更イベントにadjustHeightForMediaメソッドを設定
		window.addEventListener("resize", this.handleResize.bind(this)); // リサイズイベントにhandleResizeメソッドを設定
	}
}

export default ReadMoreLine;